import React, {
	useContext, useEffect, useRef, useState,
} from 'react';
import lottie from 'lottie-web';
import { i18n } from '../../../../symphony';
import {
	SolutionContext,
	aISolutionLoadingMessagesInLesson,
	aISolutionLoadingMessagesInPractice,
} from '../../global-constants';
import CodeCheckAnimation from '../../assets/CodeCheck.json';
import { KodieContext } from '../../services/context';

export function AISolutionLoading() {
	const animationRef = useRef<HTMLDivElement>();
	const secondsBetweenMessages = 3;
	const [passedSeconds, setPassedSeconds] = useState(0);
	const { context } = useContext(KodieContext);
	const loadingMessages = context === SolutionContext.Lesson
        	? aISolutionLoadingMessagesInLesson
        	: aISolutionLoadingMessagesInPractice;

	useEffect(() => {
		const intervalId = setInterval(() => {
			setPassedSeconds((s) => s + 1);
		}, 1000);

		return () => {
			clearInterval(intervalId);
		};
	}, []);

	useEffect(() => {
		if (animationRef.current) {
			lottie.loadAnimation({
				container: animationRef.current,
				renderer: 'svg',
				loop: true,
				autoplay: true,
				animationData: CodeCheckAnimation,
			});
		}
	}, [animationRef]);

	return (
		<>
			<div
				ref={animationRef}
				className="ai-solutions__main-section__solution__content__loading-animation"
			/>
			<div className="ai-solutions__main-section__solution__content__loading-text">
				{i18n.t(
					loadingMessages[
						passedSeconds
                        >= secondsBetweenMessages * loadingMessages.length
							? secondsBetweenMessages
							: Math.floor(passedSeconds / secondsBetweenMessages)
					],
				)}
			</div>
		</>
	);
}
